import React from 'react';
import Box from '@material-ui/core/Box';
import Logo from '../Logo';
import { LinearProgress } from '@material-ui/core';

export default () => (
  <Box width={180} display="flex" flexDirection="column" justifyContent="center">
    <Logo />
    <Box mt={2}>
      <LinearProgress aria-label="loading indicator" />
    </Box>
  </Box>
);
